import UserLayout from "../../../layouts/user";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ড্যাশবোর্ড",
  },
];

export default function UserSetting() {
  return (
    <UserLayout title="সেটিংস" breadcrumb={breadcrumb}>
      <div></div>
    </UserLayout>
  );
}
